import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { DocumentSourceEnum } from '@zaoblako/shared/modules/document/enums/document-source.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link DocumentSourceEnum} enumeration values */
export const DocumentSourceEnumI18n: EnumI18nInterface<DocumentSourceEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [DocumentSourceEnum.ERP_1C]: 'Выгружен из 1С',
    [DocumentSourceEnum.FRM]: 'Создан в ФРМ',
    [DocumentSourceEnum.BANK_STATEMENT]: 'Создан из банковской выписки',
    [DocumentSourceEnum.BALANCE_SHEET]: 'Создан из ОСВ',
  },
  [I18nLocalesEnum.EN_US]: {
    [DocumentSourceEnum.ERP_1C]: 'Downloaded from 1C ERP database',
    [DocumentSourceEnum.FRM]: 'Created in FRM',
    [DocumentSourceEnum.BANK_STATEMENT]: 'Created from bank statement',
    [DocumentSourceEnum.BALANCE_SHEET]: 'Created from balance sheet report',
  },
};
